import purchaseApi from '@/modules/projectA/api/purchase';
import userApi from '@/modules/projectA/api/user';
import tipDialog from './TreeDialog';

export default {
  components: {
    tipDialog,
  },
  data() {
    return {
      isTreeTip: false,
      tipVisible: false,
      isPrice: '',
    };
  },
  methods: {
    closeEnquiryDialog() {
      this.tipVisible = false;
      this.isTreeTip = false;
      this.isPrice = '';
    },
    async handleEnquiry(tip) {
      console.log('handleEnquiry:', tip);
      this.isPrice = tip;
      // 是否开通易专采
      const userRes = await userApi.isOpenPurchaseArea();
      if (userRes.code === '200') {
        const isOpenPurchase = userRes.data;
        if (!isOpenPurchase) {
          this.tipVisible = true;
          return false;
        }
      }

      // 是否 配置组织架构
      const res = await purchaseApi.getSelectTreeHasStop();
      if (res.code === '200') {
        const { data: { childList = [] } = {} } = res;
        if (childList.length === 0) {
          this.isTreeTip = true;
        }
      }

      if (this.isTreeTip) {
        this.tipVisible = true;
        return false;
      }

      return true;
    },
  },
};
